import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class VoucherSearchUpdateService {
  constructor(private readonly http: HttpClient) {}

  getVoucherListPage(
    itemsPerPage?: any,
    pageNumber?: any,
    isCampaign?:boolean,
    merchantId?: any,
    typeId?: any,
    name?: any,
    fromDateSearch?: any,
    toDateSearch?: any,
    category?: any,
    locations?: any,
    active?:any,
    sort?:any
  ) {
    let params = new HttpParams()
    let headers = new HttpHeaders()
    headers = headers.set('partner', '1')
    if (merchantId) {
      params = params.set('merchants', merchantId)
    }
    if (typeId) {
      params = params.set('voucherTypes', typeId)
    }
    if (name) {
      params = params.set('search', name)
    }
    if (fromDateSearch) {
      params = params.set('startDate', fromDateSearch)
    }
    if (toDateSearch) {
      params = params.set('endDate', toDateSearch)
    }
    if (category) {
      params = params.set('categories', category)
    }
    if (locations) {
      params = params.set('locations', locations)
    }
    if (active) {
      params = params.set('active', true)
    }
    if(sort) {
      params = params.set('sort',sort)
    }
    if(isCampaign!==undefined){
      params = params.set('isCampaign', isCampaign)
    }
    return this.http.get<any>(
      `mhvoucher/vouchers?page=${pageNumber}&limit=${itemsPerPage}&${params}`,
      { headers: headers },
    )
  }

  getVoucherSearchDetail(voucherType: any, voucherTitle:any, active:any) {
    let headers = new HttpHeaders()
    headers = headers.set('partner', '1')
    let params = new HttpParams()
    if (voucherType) {
      params = params.set('voucherTypes', voucherType)
    }
    if (voucherTitle) {
      params = params.set('search', voucherTitle)
    }
    if (active) {
      params = params.set('active', true)
    }
    return this.http.get<any>(`mhvoucher/vouchers?${params}`, { headers: headers })
  }
}
